import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/modal';
import Icon from 'components/icon';

import './style.css';

class LegendTitle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      infoModalOpen: false
    };

    this.onClickInfo = this.onClickInfo.bind(this);
    this.onCloseInfoModal = this.onCloseInfoModal.bind(this);
  }

  onClickInfo() {
    this.setState({ infoModalOpen: true });
  }

  onCloseInfoModal() {
    this.setState({ infoModalOpen: false });
  }

  render() {
    const { pollutant, legendValues } = this.props;
    const { infoModalOpen } = this.state;
    if (!pollutant || pollutant === {}) {
      return null;
    }

    return (
      <div className="c-legend-title">
        <div className="title">
          {pollutant.label}
        </div>
        {legendValues.length && (
          <span className="units">{legendValues[0].unit}</span>
        )}
        <div
          aria-hidden="true"
          className="info-btn"
          onClick={this.onClickInfo}
        >
          <Icon name="icon-info" />
        </div>
        <Modal
          title={pollutant.label}
          isOpen={infoModalOpen}
          onRequestClose={this.onCloseInfoModal}
        >
          <div className="info-modal">
            {pollutant.description}
          </div>
        </Modal>
      </div>
    );
  }
}

LegendTitle.propTypes = {
  pollutant: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    description: PropTypes.string
  })
};

LegendTitle.defaultProps = {
  pollutant: {}
};

export default LegendTitle;



// WEBPACK FOOTER //
// ./src/components/legend/legend-title/index.js